import { TableContainer } from "../../styles";
import { CampoValor } from "../../types";

interface BlocoPrincipalProps {
    campos: CampoValor[];
}

export default function BlocoPrincipal({ campos }: BlocoPrincipalProps) {
    return (
        <div className="expanded-section">
            <h4 className="section-title">Principal</h4>
            <TableContainer>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th className="field-col">Campo</th>
                            <th className="value-col">Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {campos.map((campo, i) => (
                            <tr key={i} className={i > 0 ? 'border-top' : ''}>
                                <td className="field-cell">{campo.campo}</td>
                                <td className={`value-cell ${campo.valor === '—' ? 'empty-value' : ''}`}>
                                    {campo.valor}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </TableContainer>
        </div>
    );
}

